(function initBreadcrumbOverflow() {
  const trigger = document.querySelector('[data-breadcrumb-trigger]');
  const menu = document.querySelector('[data-breadcrumb-menu]');
  const closeDurationMs = 360;
  let pressedItem = null;
  let pressedLink = null;
  let clearPressedTimeoutId = null;

  if (!trigger || !menu) return;

  function getMenuTarget(event) {
    const item = event.target.closest('.menu__item');
    const link = item ? item.querySelector('.list-item') : null;

    if (!item || !link) return null;

    return { item, link };
  }

  function clearPressedState() {
    if (pressedItem) {
      pressedItem.classList.remove('is-pressed');
      pressedItem = null;
    }

    if (pressedLink) {
      pressedLink.classList.remove('is-pressed');
      pressedLink = null;
    }

    if (clearPressedTimeoutId !== null) {
      window.clearTimeout(clearPressedTimeoutId);
      clearPressedTimeoutId = null;
    }
  }

  function setPressedState(item, link) {
    clearPressedState();
    pressedItem = item;
    pressedLink = link;
    pressedItem.classList.add('is-pressed');
    pressedLink.classList.add('is-pressed');
  }

  function closeMenu() {
    trigger.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');
    menu.classList.remove('is-open');

    clearPressedTimeoutId = window.setTimeout(clearPressedState, closeDurationMs);
  }

  trigger.addEventListener('click', function () {
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      closeMenu();
      return;
    }

    trigger.setAttribute('aria-expanded', 'true');
    menu.setAttribute('aria-hidden', 'false');
    menu.classList.add('is-open');
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.breadcrumb__overflow-wrap')) {
      closeMenu();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeMenu();
    }
  });

  menu.addEventListener('pointerdown', function (event) {
    const target = getMenuTarget(event);

    if (!target) return;

    setPressedState(target.item, target.link);
  });

  menu.addEventListener('click', function (event) {
    const target = getMenuTarget(event);

    if (!target) return;

    closeMenu();
  });
})();
